import { Component, OnInit, ViewChild } from '@angular/core';

import { SidePanelBase } from '../../../common/components/side-panel-base.class';
import { SidePanelService } from '../../../common/services/side-panel.service';

@Component({
    selector: 'add-navigation-item',
    templateUrl: './add-navigation-item.component.html',
    standalone: false
})
export class AddNavigationItemComponent extends SidePanelBase implements OnInit {
    static componentName = 'AddNavigationItemComponent';
    public moduleTitle: string;

    public module: boolean;

    @ViewChild('form', { static: true })
    public form: any;

    constructor(public sidePanelService: SidePanelService) {
        super();
    }

    ngOnInit(): void {
        this.module = this.componentData.moduleGroup ? true : false;
    }

    cancelForm(): void {
        this.sidePanelService.toggleSidePanel(false);
        this.form.reset();
    }

    saveForm(): void {
        if(this.module) {
            this.saveMethod.emit({ type: 'module', title: this.moduleTitle });
            this.form.reset();
            this.sidePanelService.toggleSidePanel(false);
        } else {
            this.saveMethod.emit({ type: 'moduleGroup', title: this.moduleTitle });
            this.form.reset();
            this.sidePanelService.toggleSidePanel(false);
        }
    }
}
